/**
 * cutting the mustard pre:
 * ------------------------
 * http://responsivenews.co.uk/post/18948466399/cutting-the-mustard
 * http://gomakethings.com/ditching-jquery-for-vanilla-js/
 */

 if ( 'querySelector' in document && 'addEventListener' in window ) {

 /**
  * we made it, you can do this.
  * ----------------------------
  */
  